import { combineReducers } from "@reduxjs/toolkit";
import cartIdReducer from "./cart-id";

const cartReducer = combineReducers({
  cartCountData: cartIdReducer,
});

export { cartReducer };
